import React from 'react';
import { FlexContainer } from '../Styled/FlexContainer';

const Home = () => {
  
  return (
    <FlexContainer><h2>Thank you</h2></FlexContainer>
  );
}
export default Home;